export const homeFaqItems = [
  {
    question: "What is 96KuliMarathaSurnameList.com Vadhu Var Search?",
    answer:
      "96KuliMarathaSurnameList.com Maratha Vadhu Var search is an online brand of 'Marathi Vadhu Var Suchak', which showcase well educated Maratha Vadhu Var list on single click. This service is simply a free online classified of 'Marathi Vadhu Var Suchak'.",
  },
  {
    question: "What are the benefits of 96KuliMarathaSurnameList.com Vadhu Var Search?",
    answer:
      "Well educated Maratha Samaj Vadhu Var can search and view verified profiles on just a one click with a short information with photo.",
  },
  {
    question: "How could I add my profile on 96KuliMarathaSurnameList.com Vadhu Var list?",
    answer:
      "Very easy! Just register free through the 'MarathiVadhuVarSuchak.com' app. And your profile will be displayed on 96KuliMarathaSurnameList.com list too.",
  },
  {
    question:
      "How could I see the full profile, viewed on 96KuliMarathaSurnameList.com search?",
    answer:
      "First you have to register free on 'MarathiVadhuVarSuchak.com' and where you can see the full profile, which was viewed on 96KuliMarathaSurnameList.com Vadhu Var search result.",
  },
  {
    question: "Can I use 96KuliMarathaSurnameList.com Vadhu Var search for free?",
    answer:
      "Yes! 96KuliMarathaSurnameList.com Vadhu Var search is free. And parent site 'MarathiVadhuVarSuchak.com' also allowed free online registration.",
  },
] as const;
